import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

const AreaTalhao = (
  props: {
    talhoesSelecionados: any,
  },
): JSX.Element => {
  const { talhoesSelecionados } = props;

  const getAreaComponent = (talhoesSelecionadosP): JSX.Element => {
    let talhaoArea = 0.0;

    for (const talhao in talhoesSelecionadosP) {
      if (talhoesSelecionadosP[talhao].area != null) {
        talhaoArea += talhoesSelecionadosP[talhao].area;
      }
    }

    talhaoArea = talhaoArea.toFixed(2);

    return (
      <Row className="param-row area-talhao">
        <Col>
          {`Área total dos talhões selecionados: ${talhaoArea.toString().replace('.', ',')} hectares`}
        </Col>
      </Row>
    );
  };

  return (
    <div>{getAreaComponent(talhoesSelecionados)}</div>
  );
};

AreaTalhao.propTypes = {
  talhoesSelecionados: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

AreaTalhao.defaultProps = {};

export default AreaTalhao;
